import { useAuth } from './AuthProvider';
import { useIsAdmin } from './useRequireRole';

export interface TraegerAccessResult {
  hasAccess: (traegerId: string | null | undefined) => boolean;
  allowedTraegerIds: string[];
  isAllAccess: boolean;
}

/**
 * Admin sees all Träger; everyone else only those listed in token claims.
 */
export function useTraegerAccess(): TraegerAccessResult {
  const { traegerIds } = useAuth();
  const isAdmin = useIsAdmin();

  return {
    hasAccess: (id) => {
      if (!id) return false;
      if (isAdmin) return true;
      return traegerIds.includes(id);
    },
    allowedTraegerIds: traegerIds,
    isAllAccess: isAdmin,
  };
}
